<!-- <app-address></app-address> -->
<form #contactForm="ngForm" class="pl-2">
    <div class="row" style="width: 100%;" *ngIf="isCreateOrEdit">
        <!-- company name -->
        <div class="col-md-6 pr-0">
            <div class="formGroup">
                <div class="d-flex justify-content-between">

                    <label class="label">Company Name</label>

                    <div class="d-flex align-items-center gap-1 " *ngIf="appTransactionsForViewDto?.buyerCompanySSIN == '' && activeTab==shoppingCartoccordionTabs.BuyerContactInfo">
                      
                        <input
                        type="checkbox"
                        name="company"
                        class="m-2"
                        [(ngModel)]="comNew"
                        (change)="createManualCompany($event,'company')"
                     
                    />
                    <div class="tooltip-container" >
                        <label for="ny" class="p-0 mb-0">Create new </label>
                        <!-- <svg class="mx-2" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 10.008L5.468 6.5H4.25V5.5H6.651L6.681 9.008H7.8V10.008H5.5ZM5.25 3.806C5.24285 3.5943 5.3169 3.38787 5.457 3.229C5.59433 3.07567 5.791 2.99933 6.047 3C6.303 3 6.501 3.07667 6.641 3.23C6.781 3.38267 6.85067 3.57467 6.85 3.806C6.85 4.034 6.78 4.22333 6.64 4.374C6.5 4.52467 6.30233 4.6 6.047 4.6C5.79167 4.6 5.595 4.52467 5.457 4.374C5.31636 4.21903 5.24202 4.01512 5.25 3.806ZM6 11.5C7.32608 11.5 8.59785 10.9732 9.53553 10.0355C10.4732 9.09785 11 7.82608 11 6.5C11 5.17392 10.4732 3.90215 9.53553 2.96447C8.59785 2.02678 7.32608 1.5 6 1.5C4.67392 1.5 3.40215 2.02678 2.46447 2.96447C1.52678 3.90215 1 5.17392 1 6.5C1 7.82608 1.52678 9.09785 2.46447 10.0355C3.40215 10.9732 4.67392 11.5 6 11.5ZM6 12.5C5.21207 12.5 4.43185 12.3448 3.7039 12.0433C2.97595 11.7417 2.31451 11.2998 1.75736 10.7426C1.20021 10.1855 0.758251 9.52405 0.456723 8.7961C0.155195 8.06815 0 7.28793 0 6.5C0 5.71207 0.155195 4.93185 0.456723 4.2039C0.758251 3.47595 1.20021 2.81451 1.75736 2.25736C2.31451 1.70021 2.97595 1.25825 3.7039 0.956723C4.43185 0.655195 5.21207 0.5 6 0.5C7.5913 0.5 9.11742 1.13214 10.2426 2.25736C11.3679 3.38258 12 4.9087 12 6.5C12 8.0913 11.3679 9.61742 10.2426 10.7426C9.11742 11.8679 7.5913 12.5 6 12.5Z" fill="#777777"/>
                        </svg>
                        <span class="tooltip">please check this option to create a new account using the entered data</span> -->
                    </div>
                    
                            
                    </div>
                </div>
                <!-- <p-dropdown [filter]="true"   [filterValue]="companyFilterValue" (onFilter)="handleCompanySearch($event)" class="w-100" [placeholder]="tempAccount ? companyNamePlaceholder : defaultcompanyNamePlaceholder" 
                  [options]="companeyNames"
                    *ngIf="activeTab!=shoppingCartoccordionTabs.orderInfo && activeTab!=shoppingCartoccordionTabs.SellerContactInfo" [(ngModel)]="appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex].selectedCompany"
                    [ngClass]="{'tempAccount': tempAccount}" 
                    optionLabel="name" name="selectedCompany"  [virtualScroll]="true" [itemSize]="30" (onChange)="onChangeCompany();companyFilterValue=''" ></p-dropdown> -->
                  


                    <p-autoComplete
                    [ngClass]=" tempAccount ? 'tempAccount' : ''" 
                      *ngIf="activeTab!=shoppingCartoccordionTabs.orderInfo && activeTab!=shoppingCartoccordionTabs.SellerContactInfo"
                    #autoComplete
                    [dropdown]="true"
                    [suggestions]="companeyNames"  
                    [ngModelOptions]="{standalone: true}"
 
                     
                    [(ngModel)]="appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex].selectedCompany"
                    (completeMethod)="handleCompanySearch($event)"
                    (onSelect)="onChangeCompany($event)"
                    (change)="appTransactionsForViewDto?.buyerCompanySSIN == '' ? addName($event) : ''"
                    [placeholder]="tempAccount ? companyNamePlaceholder : defaultcompanyNamePlaceholder" 
                    field="name" 
                    [forceSelection]="false" 
                  
                    class="w-100" 
                    [ngClass]="{'tempAccount': tempAccount}" 
          >
                    
                 
                </p-autoComplete>
                <div *ngIf="activeTab==shoppingCartoccordionTabs.orderInfo || activeTab==shoppingCartoccordionTabs.SellerContactInfo">
                    <p class="previewValue text-nowrap m-0 p-0  pl-2 col-6" *ngIf="appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedCompany?.name">
                        {{ appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedCompany?.name}}
                    </p>
                    <p class="previewValue text-nowrap m-0 p-0 pl-5 col-6" *ngIf="!appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedCompany?.name">
                        -
                    </p>
                </div>
            </div>
       
        </div>
        <!-- company name -->

        <!-- phone -->
        <div class="col-md-6 pl-3">
            <div class="row">
                <div class="col-6 pl-md-4">
                    <label class="label">Phone Type</label>
                </div>
                <div class="col">
                    <label class="label">Phone Number</label>
                </div>
                <div class="col-12 pl-md-2 pl-0">
                    <div class="groupForm">
                        <!-- <p-autoComplete
                        #autoComplete
                        [dropdown]="true"
                        [suggestions]="filteredPhoneTypes"  
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex].selectedPhoneType" 
                        (completeMethod)="handlePhoneSearch($event)"
                        (onSelect)="onchangePhoneType($event)"
                       
                    
                        field="phoneTypeName" 
                        [forceSelection]="false" 
                      
                        class="w-100" 
                       
              >
                        
                     
                    </p-autoComplete> -->
                        <p-dropdown [options]="allPhoneTypes"
                        class=" col-6"
                            styleClass="form-control aria-select aria-select-modal aria-select-primeng" [filter]="false"
                            name="selectedPhoneType" optionLabel="phoneTypeName"  [(ngModel)]="appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex].selectedPhoneType" [style]="{'width':'100%'}"
                            (onChange)="onchangePhoneType($event)"></p-dropdown>
                        <div class="w-100">
                            <!-- [readonly]="!appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedPhoneType" 
                                [disabled]="!appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedPhoneType"
                                [ngStyle]="{
                                    'cursor': !appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedPhoneType ? 'not-allowed' : 'pointer'}"  -->
                            <input placeholder="Phone Number..." type="text" class="form-control ml-3 w-100"
                            (change)="onChangePhoneNumber($event)"
                                [(ngModel)]="appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex].selectContactPhoneNumber"
                                #phoneNumberInput="ngModel"  name="phoneNumber" minlength="5" maxlength="20"
                                pattern="^(\+?[1-9]\d{0,2}(\s|-)?\(?\d{1,4}\)?(\s|-)?\d{1,4}(\s|-)?\d{1,4}|\(?\d{3}\)?(\s|-)?\d{3}(\s|-)?\d{4}|\d{7,15})$"

                                />
                        </div>
                    </div>
                    <div *ngIf="phoneNumberInput.invalid && (phoneNumberInput.dirty || phoneNumberInput.touched)" class="text-danger">
                        <small *ngIf="phoneNumberInput.errors?.pattern">
                            Please enter a valid phone number.
                        </small>
                        <small *ngIf="!phoneNumberInput.errors?.pattern && (phoneNumberInput.value.length < 5 || phoneNumberInput.value.length > 20)">
                            Phone number must be between 5 and 20 characters long.
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <!-- phone -->

        <!-- contact name -->
        <div class="col-md-6 my-2 pr-0">
            <div class="formGroup">
                <div class="d-flex justify-content-between">

                    <label class="label">Contact Name</label>

                    <div class="d-flex align-items-center gap-1 " *ngIf="appTransactionsForViewDto?.buyerCompanySSIN == '' && activeTab==shoppingCartoccordionTabs.BuyerContactInfo">
                     
         
                        <input
                        type="checkbox"
                        name="contact"
                        class="m-2"
                        [(ngModel)]=" conNew"
                        
                        (change)="createManualCompany($event,'contact')"
                     
                    />
                    <div class="tooltip-container" >
                        <label for="ny" class="p-0 mb-0">Create new </label>
                        <!-- <svg class="mx-2" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 10.008L5.468 6.5H4.25V5.5H6.651L6.681 9.008H7.8V10.008H5.5ZM5.25 3.806C5.24285 3.5943 5.3169 3.38787 5.457 3.229C5.59433 3.07567 5.791 2.99933 6.047 3C6.303 3 6.501 3.07667 6.641 3.23C6.781 3.38267 6.85067 3.57467 6.85 3.806C6.85 4.034 6.78 4.22333 6.64 4.374C6.5 4.52467 6.30233 4.6 6.047 4.6C5.79167 4.6 5.595 4.52467 5.457 4.374C5.31636 4.21903 5.24202 4.01512 5.25 3.806ZM6 11.5C7.32608 11.5 8.59785 10.9732 9.53553 10.0355C10.4732 9.09785 11 7.82608 11 6.5C11 5.17392 10.4732 3.90215 9.53553 2.96447C8.59785 2.02678 7.32608 1.5 6 1.5C4.67392 1.5 3.40215 2.02678 2.46447 2.96447C1.52678 3.90215 1 5.17392 1 6.5C1 7.82608 1.52678 9.09785 2.46447 10.0355C3.40215 10.9732 4.67392 11.5 6 11.5ZM6 12.5C5.21207 12.5 4.43185 12.3448 3.7039 12.0433C2.97595 11.7417 2.31451 11.2998 1.75736 10.7426C1.20021 10.1855 0.758251 9.52405 0.456723 8.7961C0.155195 8.06815 0 7.28793 0 6.5C0 5.71207 0.155195 4.93185 0.456723 4.2039C0.758251 3.47595 1.20021 2.81451 1.75736 2.25736C2.31451 1.70021 2.97595 1.25825 3.7039 0.956723C4.43185 0.655195 5.21207 0.5 6 0.5C7.5913 0.5 9.11742 1.13214 10.2426 2.25736C11.3679 3.38258 12 4.9087 12 6.5C12 8.0913 11.3679 9.61742 10.2426 10.7426C9.11742 11.8679 7.5913 12.5 6 12.5Z" fill="#777777"/>
                        </svg>
                        <span class="tooltip">please check this option to create a new account using the entered data</span> -->
                    </div>
                    
                            
                    </div>
                </div>
<!--                
                <p-dropdown   [filter]="true" [filterValue]="contactFilterValue" (onFilter)="handleContactSearch($event)" class="w-100" [placeholder]="tempContact ? contactNamePlaceholder : tempAccount ? contactNamePlaceholder  : defaultcontactNamePlaceholder" 
                placeholder="Select Contact Name" [options]="allContacts"
                *ngIf="activeTab!=shoppingCartoccordionTabs.orderInfo" [(ngModel)]="appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex].selectedContact"
                [ngClass]="{'tempAccount': tempContact}"  optionLabel="name" name="selectedContact" (onChange)="onChangeContact($event)" ></p-dropdown>
            -->

      
         
            <p-autoComplete
            #autoComplete
            [dropdown]="!tempAccount"
            [suggestions]="filteredContacts "  
            [ngModelOptions]="{standalone: true}"
            *ngIf="activeTab != shoppingCartoccordionTabs.orderInfo"
            [(ngModel)]="appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex].selectedContact"
            (completeMethod)="handleContactSearch($event);"
            (onSelect)="onChangeContact($event)"
            (click)="onClearText()"
            (onClear)="onClearText()"
            [placeholder]=" defaultcontactNamePlaceholder"
            field="name" 
            [forceSelection]="false" 
          
            class="w-100" 
            [ngClass]="tempAccount ?  'tempCon' : ''" 
  >
            
         
        </p-autoComplete>
        
                        
                    <div *ngIf="activeTab==shoppingCartoccordionTabs.orderInfo">
                    <p class=" previewValue text-nowrap  m-0 p-0 pl-2 col-4" *ngIf="appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedContact?.name">
                        {{ appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedContact?.name }}
                    </p>
                    <p class=" previewValue text-nowrap  m-0 p-0  pl-5 col-4" *ngIf="!appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedContact?.name">
                        -
                    </p>
                </div>
            </div>
        </div>
        <!-- contact name -->

        <!-- Email -->
        <div class="col-md-6 my-2 pr-0 pl-md-4">
            <div>
                <label class="label">Email</label>
                <input type="text" placeholder="Email..." class="form-control w-100"
                (change)="onChangeEmail($event)"
                [pattern]="emailPattern"
                #emailInput="ngModel"
                    [(ngModel)]="appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex].selectedContactEmail"
                    name="email" />
            </div>
            <div *ngIf="emailInput.errors &&(emailInput.touched || emailInput.dirty)" class="text-danger">
        <small >
            Invalid  Email
        </small>
        </div>
        </div>
        <!-- Email -->

        <!-- branches -->
        <div class="col-md-12 my-2 pr-0">
            <div>
                <label class="label">Branch</label>
                <!-- <p-dropdown class="w-50" placeholder="Select Branch" [options]="allBranches"
                    [(ngModel)]="appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex].selectedBranch" optionLabel="name" name="branch" appendTo="body"
                    baseZIndex="99999"></p-dropdown> -->


                    <p-autoComplete
                  
                  #autoComplete
                  [dropdown]="true"
                  [suggestions]="filteredBranches"  
                  [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex].selectedBranch" 
                  (keydown)="preventTyping($event)"  
                  (completeMethod)="handleBranchSearch($event)"
                  [placeholder]="appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex].selectedBranch || ' Main'"
                  field="name" 
                  [forceSelection]="false" 
                  class="w-100" 
                  [ngClass]="{'tempAccount': tempContact}" 
        >
                  
               
              </p-autoComplete>
            </div>
        </div>
        <!-- branches -->

        <!-- Department -->
        <div class="col-md-12 my-2 pr-0" *ngIf="showDepartment">
            <div>
                <label class="label">Department</label>
                <input type="text" placeholder="Department Name..." class="form-control w-100" name="DepartmentName"
                    [(ngModel)]="appTransactionsForViewDto.buyerDepartment" #DepartmentName="ngModel"  />
                <div *ngIf="
                    DepartmentName.invalid &&
                        (DepartmentName.dirty || DepartmentName.touched)
                    " class="text-danger">
                    <small *ngIf="DepartmentName.errors.required">
                        Department Name is required.
                    </small>
                </div>
            </div>
        </div>
        <!-- Departments -->
    
    </div>

    <div class="row" *ngIf="!isCreateOrEdit">
        <!-- company name -->
        <div class="col-md-6 my-2">
            <div>
                <div class="d-flex align-items-center   w-100">
                    <h6 class="previewTitle m-0 p-0  col-6">Company :</h6>
                    <p class=" previewValue text-nowrap  m-0 p-0  col-6" *ngIf="appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedCompany?.name  || appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.companyName">
                        {{ appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedCompany?.name   ?     appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedCompany?.name : appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.companyName}}
                    </p>
                    <p class=" previewValue text-nowrap  m-0 p-0  col-6" *ngIf="!appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedCompany?.name  && !appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.companyName">
                        -
                    </p>
                </div>
            </div>
        </div>
        <!-- company name -->

        <!-- phone -->
        <div class="col-md-6 my-2">
            <div class="row">
                <div class="col-md-12">
                    <div class="d-flex align-items-center   w-100">
                        <h6 class="previewTitle m-0 p-0  col-md-3 col-6">Phone : </h6>
                        <p class=" previewValue text-nowrap  m-0 p-0  col-md-9 col-6" 
                            *ngIf="appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectContactPhoneNumber || appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex]?.contactPhoneNumber">
                            {{appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectContactPhoneNumber ? appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectContactPhoneNumber  : appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex]?.contactPhoneNumber}}
                        </p>
                        <p class=" previewValue text-nowrap  m-0 p-0 col-md-9 col-6 pl-2"
                            *ngIf="!appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectContactPhoneNumber && !appTransactionsForViewDto.appTransactionContacts[this.appTransactionContactsIndex]?.contactPhoneNumber">
                            -
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- phone -->

        <!-- contact name -->
        <div class="col-md-6 my-2">
            <div>
                <div class="d-flex align-items-center   w-100">
                    <h6 class="previewTitle m-0 p-0  col-6">Contact Name :</h6>
                    <p class=" previewValue text-nowrap  m-0 p-0  col-6" *ngIf="appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedContact?.name || this.appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.contactName">
                        {{ appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedContact?.name ? appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedContact?.name :  this.appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.contactName}}
                    </p>
                    <p class=" previewValue text-nowrap  m-0 p-0  col-6" *ngIf="!appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.selectedContact?.name  && !this.appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.contactName">
                        -
                    </p>
                </div>
            </div>
        </div>
        <!-- contact name -->

        <!-- Email -->
        <div class="col-md-6 my-2">
            <div>
                <div class="d-flex    w-100">
                    <h6 class="previewTitle m-0 p-0  col-md-3 col-6">Email :</h6>
                    <p class=" previewValue  m-0 p-0  col-md-9 col-6" style="word-break: break-word;"
                        *ngIf="appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.contactEmail ">
                        {{
                        appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.contactEmail
                        }}
                    </p>
                    <p class=" previewValue text-nowrap  m-0 p-0  col-md-9 col-6"
                        *ngIf="!appTransactionsForViewDto?.appTransactionContacts[this.appTransactionContactsIndex]?.contactEmail ">
                        -
                    </p>
                </div>
            </div>
        </div>
        <!-- Email -->

        <!-- branches -->
        <div class="col-md-6 my-2">
            <div>
                <div class="d-flex align-items-center   w-100">
                    <h6 class="previewTitle m-0 p-0  col-6">Branch :</h6>
                    <p class=" previewValue text-nowrap  m-0 p-0  col-6"
                        *ngIf="appTransactionsForViewDto?.appTransactionContacts[appTransactionContactsIndex]?.branchName">
                        {{ appTransactionsForViewDto?.appTransactionContacts[appTransactionContactsIndex]?.branchName }}
                    </p>
                    <p class=" previewValue text-nowrap  m-0 p-0  col-6"
                        *ngIf="!appTransactionsForViewDto?.appTransactionContacts[appTransactionContactsIndex]?.branchName">
                        -
                    </p>
                </div>
            </div>
        </div>
        <!-- branches -->

        <!-- Department -->
        <div class="col-md-11 my-2" *ngIf="showDepartment">
            <div>
                <div class="d-flex align-items-center   w-100">
                    <h6 class="previewTitle m-0 p-0   col-6">Department Name :</h6>
                    <p class=" previewValue text-nowrap  m-0 p-0  col-6" *ngIf="appTransactionsForViewDto?.buyerDepartment">
                        {{ appTransactionsForViewDto?.buyerDepartment }}
                    </p>
                    <p class=" previewValue text-nowrap  m-0 p-0  col-6" *ngIf="!appTransactionsForViewDto?.buyerDepartment">
                        -
                    </p>
                </div>
            </div>
        </div>
        <!-- Departments -->

    </div>
</form>